import http from 'hub-http/clients/apiClient';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'task... Remove this comment to see the full error message
import { TaskQueueManager as TaskQueueManagerClass } from 'task-queues/TaskQueueManager';
import { StorageWrapper } from 'task-queues/storage/StorageWrapper';
const storage = new StorageWrapper(sessionStorage);

// Configure the task queue lib for this app
export const TaskQueueManager = new TaskQueueManagerClass(http, storage);